module.exports = __webpack_public_path__ + "booksapple_blue.svg?dac06dbfb7d8ae3906c8b2937c24ca82";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/home/icons/booksapple_blue.svg
// module id = 145
// module chunks = 0